export enum SnackBarType
{
    SUCCESS = 'success',
    WARN = 'warn',
    ERROR = 'error'
}
